export default [
    "24 24",
    '<path d="M24 3V3C12.402 3 3 12.402 3 24V24" stroke="var(--ci-primary-color, currentColor)" fill="none" stroke-width="4.5"/>'
]

